import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles/createMuiTheme" {
  interface Theme {
    status: {
      danger: string
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string
    }
  }
}

const theme = createMuiTheme({
  overrides: {
    MuiContainer: {
      maxWidthLg: {
        maxWidth: "1280px !important",
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "0 0 3px rgba(100,100,100,0.2)",
      },
    },
    MuiCard: {
      root: {
        borderRadius: "40px",
      },
    },
    MuiCardContent: {
      root: {
        padding: "24px",
        "&:last-child": {
          paddingBottom: "24px",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#fa0e1c",
    },
    text: {
      primary: "#fff",
      secondary: "#1774d0",
    },
  },
  typography: {
    fontFamily: "'Overpass', sans-serif",
    fontSize: 18,
  },
})

export default theme
